<main>
    <section class="print:hidden flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">Informe de existencias</h1>

        <button type="button" [disabled]="printing" (click)="printReport()"
            class="cursor-pointer flex items-center gap-2 bg-white border border-zinc-200 text-zinc-700 px-4 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ease-in-out hover:bg-zinc-900 hover:text-white hover:border-zinc-900 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-zinc-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-zinc-700">
            <svg class="h-4 w-4" [class.animate-spin]="printing" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                @if(printing) {
                <path d="M12 3a9 9 0 1 0 9 9" />
                } @else {
                <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" rx="1" />
                }
            </svg>
            <span>{{ printing ? 'Generando...' : 'Imprimir Informe' }}</span>
        </button>
    </section>

    <sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="total"
        pageParamName="page" limitParamName="limit" [orientation]="orientation" [showOptions]="showOptions"
        [sizeInitialPage]="1" [headers]="headers" [limit]="limitNumber" [showOptions]="false"
        (itemsLoadedEvent)="finishLoad($event)">
    </sau-table>

</main>
